import React from "react";
import { transformArticleImagesForStaticHtml } from "@/platforms/customer/utils/transformArticleImagesForStaticHtml";

const BlogContentSection = ({ htmlWithIds, renderedHtml }) => {
  let content = htmlWithIds || renderedHtml || "";
  content = content.replace(/(<h[1-6][^>]*>)(.*?)(<\/h[1-6]>)/gi, (m, p1, p2, p3) => p1 + p2.replace(/<\/?(?:strong|b)\b[^>]*>/gi, "") + p3);
  
  const finalHtml = transformArticleImagesForStaticHtml(content);
  return (
    <>
      <div className="blog-content prose max-w-none prose-img:max-w-full prose-h1:text-[44px] prose-h2:text-[32px] prose-h3:text-[28px] prose-h1:font-semibold prose-h2:font-bold prose-h3:font-bold prose-h1:text-black prose-h2:text-black prose-h3:text-black prose-p:text-[15px] lg:prose-p:text-[13px] prose-p:text-black prose-a:text-[#284078] prose-a:underline prose-a:underline-offset-2 hover:prose-a:opacity-80 [&_a]:text-[#284078] [&_a]:underline [&_a]:underline-offset-2 hover:[&_a]:opacity-80 [&_img]:mx-auto [&_img]:block [&_img]:w-full [&_table]:w-full [&_table]:border-collapse [&_table]:border [&_table]:border-gray-300 [&_th]:border [&_th]:border-gray-300 [&_th]:px-3 [&_th]:py-2 [&_th]:text-left [&_td]:border [&_td]:border-gray-300 [&_td]:px-3 [&_td]:py-2">
        <style>{`
                    .blog-content,
                    .blog-content * {
                      font-family: inherit !important;
                    }
                    .blog-content h1 { font-size: 28px !important; line-height: 1.2 !important; font-weight: 600 !important; }
                    .blog-content h2 { font-size: 24px !important; line-height: 1.25 !important; font-weight: 700 !important; }
                    .blog-content h3 { font-size: 20px !important; line-height: 1.3 !important; font-weight: 700 !important; }
                    .blog-content figcaption { text-align: center !important; margin-top: 8px !important; color: #6b7280 !important; font-size: 14px !important; }
                    .blog-content h1, .blog-content h2, .blog-content h3, .blog-content h4, .blog-content h5, .blog-content h6 { padding: 15px 0 !important; }
                    .blog-content p, .blog-content span { text-align: left !important; word-spacing: normal !important; }
                    .blog-content p { margin: 0 0 15px !important; }
                    .blog-content p:empty { display: none !important; }
                    .blog-content table {
                      width: 100% !important;
                      max-width: 100% !important;
                      margin: 6px 0 0px !important;
                      table-layout: auto;
                      word-break: break-word;
                      overflow-wrap: break-word;
                    }
                    /* Some editors wrap tables in figure/div wrappers that carry large margins. */
                    .blog-content figure,
                    .blog-content figure.table,
                    .blog-content .table,
                    .blog-content .table-responsive {
                      width: 100% !important;
                      max-width: 100% !important;
                      margin: 6px 0 0px !important;
                    }
                    .blog-content figure > table,
                    .blog-content figure.table > table {
                      width: 100% !important;
                      max-width: 100% !important;
                      margin: 0 !important;
                    }
                    /* Reduce only the gap AFTER tables/cards (not inside table). */
                    .blog-content table + * { margin-top: 0 !important; }
                    .blog-content table + h1,
                    .blog-content table + h2,
                    .blog-content table + h3,
                    .blog-content table + h4,
                    .blog-content table + h5,
                    .blog-content table + h6 { margin-top: 0 !important; padding-top: 6px !important; }
                    /* If headings come after a table wrapper (common in CMS editors), remove top margin too. */
                    .blog-content :is(figure, .table, .table-responsive) + :is(h1,h2,h3,h4,h5,h6) {
                      margin-top: 0 !important;
                      padding-top: 6px !important;
                    }
                    /* If the next sibling is a wrapper div/span, kill the first child's top spacing. */
                    .blog-content table + div > :first-child,
                    .blog-content table + span > :first-child { margin-top: 0 !important; }
                    .blog-content table + div > :is(h1,h2,h3,h4,h5,h6):first-child,
                    .blog-content table + span > :is(h1,h2,h3,h4,h5,h6):first-child { padding-top: 6px !important; }
                    .blog-content table + div > :is(h1,h2,h3,h4,h5,h6):first-child,
                    .blog-content table + span > :is(h1,h2,h3,h4,h5,h6):first-child { margin-top: 0 !important; }
                    .blog-content :is(figure, .table, .table-responsive) + div > :is(h1,h2,h3,h4,h5,h6):first-child,
                    .blog-content :is(figure, .table, .table-responsive) + span > :is(h1,h2,h3,h4,h5,h6):first-child {
                      margin-top: 0 !important;
                      padding-top: 6px !important;
                    }
                    /*
                     * Tall portrait imgs handled by Next.js Image fill and container.
                     */
                    /* Tour card: match editor design */
                    .blog-content .ta-product-card { margin: 10px 0 6px !important; width: 100% !important; max-width: 841px; border: 1px solid #D1D5DB; border-radius: 22px; overflow: hidden; background: #ffffff; padding: 14px; box-sizing: border-box; }
                    .blog-content .ta-product-card + * { margin-top: 0 !important; }
                    .blog-content .ta-product-card + h1,
                    .blog-content .ta-product-card + h2,
                    .blog-content .ta-product-card + h3,
                    .blog-content .ta-product-card + h4,
                    .blog-content .ta-product-card + h5,
                    .blog-content .ta-product-card + h6 { padding-top: 6px !important; }
                    .blog-content .ta-product-card + div > :first-child,
                    .blog-content .ta-product-card + span > :first-child { margin-top: 0 !important; }
                    .blog-content .ta-product-card + div > :is(h1,h2,h3,h4,h5,h6):first-child,
                    .blog-content .ta-product-card + span > :is(h1,h2,h3,h4,h5,h6):first-child { padding-top: 6px !important; }
                    .blog-content .ta-product-card-layout { display: grid; grid-template-columns: 300px minmax(0, 1fr); align-items: stretch; column-gap: 20px; row-gap: 0; }
                    .blog-content .ta-product-card-media { min-height: 168px; align-self: stretch; background: #F3F4F6; border-radius: 18px; overflow: hidden; position: relative; }
                    .blog-content .ta-product-card-media { display: block; height: 248px !important; min-height: 248px !important; align-self: stretch; }
                    .blog-content .ta-product-card-media img { height: 100% !important; width: 100% !important; object-fit: cover !important; max-height: none !important; }
                    .blog-content .ta-product-card-img { border-radius: 16px !important; }
                    .blog-content .ta-product-card a { text-underline-offset: 3px; }
                    @media (max-width: 1023px) {
                      .blog-content h1 { font-size: 28px !important; line-height: 1.2 !important; }
                      .blog-content h2 { font-size: 22px !important; line-height: 1.25 !important; }
                      .blog-content h3 { font-size: 18px !important; line-height: 1.3 !important; }
                      .blog-content table { font-size: 12px !important; }
                      .blog-content table th,
                      .blog-content table td {
                        padding: 5px 7px !important;
                        font-size: 12px !important;
                        line-height: 1.35 !important;
                      }
                      .blog-content .ta-product-card { padding: 10px !important; }
                      .blog-content .ta-product-card-layout { grid-template-columns: 1fr !important; }
                      .blog-content .ta-product-card-media { height: 220px !important; min-height: 220px !important; }
                      .blog-content .ta-product-card-footer,
                      .blog-content .ta-product-card-layout > *:last-child > div:last-child:has(a.ta-product-card-btn-primary) {
                        flex-direction: column !important;
                        align-items: stretch !important;
                        flex-wrap: nowrap !important;
                        justify-content: flex-start !important;
                        gap: 10px !important;
                      }
                      .blog-content .ta-product-card-footer > div:last-child,
                      .blog-content .ta-product-card-layout > *:last-child > div:last-child:has(a.ta-product-card-btn-primary) > div:last-child {
                        display: grid !important;
                        grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) !important;
                        align-items: stretch !important;
                        gap: 8px !important;
                        width: 100% !important;
                        min-width: 0 !important;
                      }
                      .blog-content .ta-product-card-type { font-size: 11px !important; padding: 7px 10px !important; border-radius: 8px !important; }
                      .blog-content .ta-product-card-tags span { font-size: 11px !important; padding: 5px 9px !important; }
                      .blog-content .ta-product-card [style*="font-size:20px"] { font-size: 16px !important; }
                      .blog-content .ta-product-card [style*="font-size:13px"] { font-size: 12px !important; }
                      .blog-content .ta-product-card [style*="font-size:24px"] { font-size: 18px !important; }
                      .blog-content .ta-product-card-btn-primary,
                      .blog-content .ta-product-card-btn-secondary {
                        display: flex !important;
                        align-items: center !important;
                        justify-content: center !important;
                        min-width: 0 !important;
                        width: 100% !important;
                        max-width: 100% !important;
                        height: auto !important;
                        min-height: 34px !important;
                        padding: 6px 5px !important;
                        font-size: 11px !important;
                        line-height: 1.2 !important;
                        box-sizing: border-box !important;
                        text-align: center !important;
                        white-space: nowrap !important;
                      }
                    }
                    .blog-content .ta-product-card svg { flex: 0 0 auto; }
                    .blog-content .ta-product-card span { min-width: 0; }
                    .blog-content table tr:first-child > th,
                    .blog-content table tr:first-child > td { background: transparent !important; font-weight: 800 !important; color: #111827 !important;}
                  `}</style>
        <div dangerouslySetInnerHTML={{ __html: finalHtml }} />
      </div>
    </>
  );
};

export default BlogContentSection;
